import LoopIcon from '@mui/icons-material/Loop';
import { Step } from '../../components/Step';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Checkboxes } from 'mui-rff';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Table } from 'src/shared/components/Table/Table';
import { type DataTableRow, useColumns } from '../../utils/constants';

export enum COLUMN_FIELD_NAMES {
  FIRST_NAME = 'firstName',
  DOCUMENT_NUMBER = 'documentNumber',
  PAYROLL_CODE = 'payrollCode',
  CONTRACT_PHONE = 'phone',
  GROSS_SALARY = 'grossSalary',
  EMAIL = 'email'
}

export const columnFieldLabel = {
  [COLUMN_FIELD_NAMES.FIRST_NAME]: 'table.first name',
  [COLUMN_FIELD_NAMES.DOCUMENT_NUMBER]: 'table.document number',
  [COLUMN_FIELD_NAMES.PAYROLL_CODE]: 'table.payroll id',
  [COLUMN_FIELD_NAMES.EMAIL]: 'table.email',
  [COLUMN_FIELD_NAMES.CONTRACT_PHONE]: 'table.mobile',
  [COLUMN_FIELD_NAMES.GROSS_SALARY]: 'table.monthly gross remuneration'
};

export const Step4 = () => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();
  const dataTable: DataTableRow[] = Object.values(COLUMN_FIELD_NAMES).map((fieldName: COLUMN_FIELD_NAMES) => ({
    fieldInPayflow: {
      label: columnFieldLabel[fieldName],
      value: fieldName
    }
  }));
  const columns = useColumns('Castilla');

  return (
    <Step
      title={`${t('integrations.step')} 4`}
      subtitle={`${t('If you use custom fields', { softwareName: 'Castilla' })}:`}
      Icon={LoopIcon}
    >
      <>
        <Grid2 xs={12}>
          <Checkboxes
            name="withCustomFields"
            data={{ label: t('use custom fields', { ns: 'settings' }), value: true }}
          />
        </Grid2>

        {values?.withCustomFields && <Table rows={dataTable} columns={columns} />}
      </>
    </Step>
  );
};
